module.exports = __webpack_public_path__ + "img/activity.6d7289b9.png";